import { render, staticRenderFns } from "./RostockHowTo.vue?vue&type=template&id=0a79a17e&"
import script from "./RostockHowTo.vue?vue&type=script&lang=js&"
export * from "./RostockHowTo.vue?vue&type=script&lang=js&"
import style0 from "./RostockHowTo.vue?vue&type=style&index=0&id=0a79a17e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports